import { EnvironmentsAPI } from "providers/EnvironmentsAPI";
import { EnvironmentStorage } from "shared/tools/EnvironmentStorage";
import { v4 as uuid } from 'uuid';

export class Banners {

    async environment_id() {
        const environment = await EnvironmentStorage.getEnvironment();
        return environment.id;
    }

    async _get(holdingId) {
        const environment_id = await this.environment_id();
        return await EnvironmentsAPI.getConfigurationsByAlias(holdingId || environment_id, "banners");
    }
    
    async _set(banners, holdingId) {
        const environment_id = await this.environment_id();
        return await EnvironmentsAPI.putConfigurationsByAlias(holdingId ||environment_id, 'banners', { banners });
    }

    async setCategory(alias, category, holdingId) {
        const banners = await this._get(holdingId);
        banners[alias] = category;
        await this._set(banners, holdingId);
        return true;
    }

    async upsert(category, device, banner, holdingId) {
        const banners = await this._get(holdingId);
        
        if(!banner.id) {
            banner.id = uuid();
        }

        banners[category] = banners[category] || {};
        banners[category][device] = banners[category][device] || [];
        
        const banner_index = banners[category][device].findIndex((b) => b.id == banner.id);
        
        if(banner_index > -1) {
            banners[category][device][banner_index] = banner;
        } else {
            banners[category][device].push(banner);
        }

        await this._set(banners, holdingId);
        return true;
    }

    async delete(category, device, banner_id, holdingId) {
        const banners = await this._get(holdingId);
        
        banners[category] = banners[category] || {};
        banners[category][device] = banners[category][device] || [];

        banners[category][device] = banners[category][device].filter((b) => b.id != banner_id);

        await this._set(banners, holdingId);
        return true;
    }
}